module.exports = __webpack_public_path__ + "static/media/luther.3a3e2cca.png";